const useTypes = () => {
  return {
      LOGIN: "LOGIN",
      SET_ANSWER: "RESPONSES::SET_ANSWER",
      SET_HEART: "RESPONSES::SET_HEART"
  }
}

export default useTypes;